<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Customer List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by customer name"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Name</th>
            <th class="text-left">Address</th>
            <th class="text-left">Contact Numbers</th>
            <th class="text-left">Date Added</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in customers" :key="item.id" @click="showCustomer(item.id)">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ item.address }}</td>
            <td class="text-left">{{ item.contact_numbers }}</td>
            <td class="text-left">{{ item.created_at }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="4" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn
      fixed
      bottom
      right
      @click="$router.push('/customer/create')"
      color="blue darken-2"
      dark
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <customerCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <customerEdit v-if="edit" :page="page" :edit="edit" />
    <customerShow v-if="show" :show="show" :page="page" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import customerCreate from './CustomerCreate';
import customerEdit from './CustomerEdit';
import customerShow from './CustomerShow';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      paginationcount: '10'
    };
  },
  components: {
    customerCreate,
    customerEdit,
    customerShow
  },
  props: {
    create: false,
    show: false,
    edit: false
  },
  watch: {
    page(val) {
      this['Customer/fetchCustomers']({
        page: val,
        filter: this.filter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['Customer/getCustomer']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      customers: state => state.Customer.customers.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.Customer.customers.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.Customer.customers;
      }
    })
  },
  mounted() {
    this['Customer/fetchCustomers']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['Customer/fetchCustomers', 'Customer/getCustomer']),
    showCustomer(id) {
      this.$router.push(`/customer/${id}`);
    },
    filterList() {
      if (this.page !== 1) this.page = 1;
      else
        this['Customer/fetchCustomers']({
          page: this.page,
          filter: this.filter,
          paginationcount: this.paginationcount
        });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else this['Customer/fetchCustomers']({ page: 1, paginationcount: this.paginationcount });
    }
  }
};
</script>
